import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ContactFilterSkeleton = t0 => {
  const $ = _c(3);
  const {
    isLast
  } = t0;
  const t1 = `w-full px-4 ${!isLast && "border-b-text-secondary/30 border-b pb-3"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-skeleton-primary flex animate-pulse items-center gap-3 rounded-md text-transparent">.</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <><div className={t1}>{t2}</div></>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default ContactFilterSkeleton;